import React from 'react';
import { createRoot } from 'react-dom/client';
import { Button, Modal } from "react-bootstrap";

class TimeoutModalView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showModal: false }
    }
    close() {
        this.setState({ showModal: false });
    }
    open() {
        this.setState({ showModal: true });
    }
    render() {
        return (
            <div>
                <Modal onHide={this.close} dialogClassName="timeoutModal" show={this.state.showModal}>
                    <Modal.Header closeButton>
                        <Modal.Title><b>Session Timeout</b></Modal.Title>
                    </Modal.Header>

                    <div className='modal-body'>
                        <p>Your session timed out, and the last action was not processed.
                            It has been refreshed. <b>Please resubmit your action request.</b></p>
                    </div>
                    <div className='modal-footer'>
                        <Button id="timeoutConfirmButton" bsStyle='primary' onClick={this.close}>OK</Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

function initialize() {
    const root = createRoot(document.getElementById('timeoutModalDiv'));
    root.render(<TimeoutModalView />);
}

export { initialize as initializeTimeout };
